var _excluded = ["caption", "title", "titleTypography", "text", "image", "footerText", "linkType", "to", "href", "hrefTitle", "onClick", "rel", "openInNewTab", "button", "hasArrow", "backgroundColor", "isReversed"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import ButtonAtm from "../../atoms/ButtonAtm";
import TextAtm from "../../atoms/TextAtm";
import Picture from "../../quarks/Picture";
import { ContentWrapper, FooterWithArrow, TextContainer, TileMolArrow, TileMolImageWrapper, TileMolLinkBox, TileMolWrapper } from "./TileMol.styled";

// eslint-disable-next-line no-shadow
export var LinkTypes = /*#__PURE__*/function (LinkTypes) {
  LinkTypes["LINK"] = "LinkElementComponent";
  LinkTypes["BUTTON"] = "ButtonElementComponent";
  return LinkTypes;
}({});
export var defaultProps = {
  titleTypography: "large3",
  linkType: LinkTypes.LINK
};
function TileMol(_ref) {
  var caption = _ref.caption,
    title = _ref.title,
    _ref$titleTypography = _ref.titleTypography,
    titleTypography = _ref$titleTypography === void 0 ? defaultProps.titleTypography : _ref$titleTypography,
    text = _ref.text,
    image = _ref.image,
    footerText = _ref.footerText,
    _ref$linkType = _ref.linkType,
    linkType = _ref$linkType === void 0 ? defaultProps.linkType : _ref$linkType,
    to = _ref.to,
    href = _ref.href,
    hrefTitle = _ref.hrefTitle,
    onClick = _ref.onClick,
    rel = _ref.rel,
    openInNewTab = _ref.openInNewTab,
    button = _ref.button,
    hasArrow = _ref.hasArrow,
    backgroundColor = _ref.backgroundColor,
    isReversed = _ref.isReversed,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var isMediumOnly = useBreakpoint("medium", "large");
  var isLargeUp = useBreakpoint("large");
  var backgroundColorValue = backgroundColor || hasArrow && "backgroundLight" || "background";
  return /*#__PURE__*/React.createElement(TileMolWrapper, _extends({
    $hasArrow: !!hasArrow,
    $onColor: onColor,
    $backgroundColor: backgroundColorValue,
    $isReversed: !!isReversed,
    $linkType: linkType
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColorValue
  }, image && isLargeUp ? /*#__PURE__*/React.createElement(TileMolImageWrapper, null, /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  })) : null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(TextContainer, null, caption ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "xsmall2_u",
    pushSpace: 2
  }, caption) : null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: titleTypography,
    htmlTag: "h3",
    pushSpace: isMediumOnly ? 4 : 3
  }, title), text), /*#__PURE__*/React.createElement(FooterWithArrow, null, linkType === LinkTypes.LINK && /*#__PURE__*/React.createElement(TileMolLinkBox, {
    to: to,
    href: href,
    title: hrefTitle,
    openInNewTab: openInNewTab,
    onClick: onClick,
    rel: rel,
    $hasPrimaryColor: true
  }, footerText), linkType === LinkTypes.BUTTON && /*#__PURE__*/React.createElement(ButtonAtm, {
    to: to,
    href: href,
    title: hrefTitle,
    openInNewTab: openInNewTab,
    onClick: onClick,
    rel: rel,
    color: button === null || button === void 0 ? void 0 : button.color,
    variant: button === null || button === void 0 ? void 0 : button.variant,
    isWider: button === null || button === void 0 ? void 0 : button.isWider
  }, footerText), hasArrow ? /*#__PURE__*/React.createElement(TileMolArrow, null) : null))));
}
export default TileMol;